export const mediumTime = new Intl.DateTimeFormat('en', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

export const COMPANY_STATUS_PENDING = 'pending'
export const COMPANY_STATUS_REJECTED = 'rejected'
export const COMPANY_STATUS_APPROVED = 'approved'

export const Roles = {
  SuperUser: 'Super User',
  CompanyAdmin: 'Admin',
  CompanyUser: 'Company User',
  CompanySupervisor: 'Supervisor',
  TradesPerson: 'Trades Person',
}
